module.exports = __webpack_public_path__ + "static/img/avatar.96cb07a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TopBar/img/avatar.jpeg
// module id = ozNo
// module chunks = 1